var map = {
	"./messages.az.json": "130e9",
	"./messages.bn.json": "421d",
	"./messages.en.json": "1d2f",
	"./messages.es.json": "f4e5",
	"./messages.ko.json": "c27a",
	"./messages.ky.json": "8db8",
	"./messages.ru.json": "76fd",
	"./messages.tg.json": "7cfa",
	"./messages.tr.json": "c1e6",
	"./messages.uz.json": "634f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b411";